module.exports = __webpack_public_path__ + "static/media/undraw_good_team.fed09e6f.svg";